import { useState } from 'react';
import { useDonationBlockProps } from '../DonationBlockProvider';
import { useDonationNavigation } from '../libs/useDonationNavigation';
import { useAuthorizeContext } from './useAuthorizeContext';
interface IUseAuthorizeTokenResult {
    isLoading: boolean;
    requestAuthorizeToken: (submissionId: string) => void;
}

interface AuthorizeAPIReturn {
    token: string;
    paymentHandleUrl: string;
    actionFormPost: string;
    sandbox: boolean;
}

const useAuthorizeToken = (): IUseAuthorizeTokenResult => {
    const domainVerificationUrl = `${window.location.origin}/IFrameCommunicator.html`;
    // const domainVerificationUrl = `https://inte.hollows.org/IFrameCommunicator.html`;

    const { baseURL } = useDonationBlockProps();
    const { nextStep } = useDonationNavigation();
    const { setPaymentData } = useAuthorizeContext();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const requestAuthorizeToken = async(submissionId: string): Promise<void> => {
        // set loading status
        setIsLoading(true);

        // test token mock api
        // const tokenAPIUrl = `/assets/data/mock-authorize-token.json`;

        // live token api
        const tokenAPIUrl = `${baseURL}/api/authorizenet/newtoken`;

        const requestBody = new FormData();
        requestBody.append('submissionId', submissionId);
        requestBody.append('iFrameUrl', domainVerificationUrl);

        try {
            // test token
            // const request = await fetch(tokenAPIUrl, { method: 'GET' });

            // live token
            const request = await fetch(tokenAPIUrl, {
                method: 'POST',
                body: requestBody,
            });

            if (!request.ok) {
                throw new Error('Failed to get Authorize.Net token');
            }

            const result: AuthorizeAPIReturn = await request.json();

            if (!result.token) {
                throw new Error('Failed to request Authorize.Net token');
            }

            // update payment context
            setPaymentData({
                submissionId,
                token: result.token,
                sandbox: result.sandbox,
            });

            // unset loading status
            setIsLoading(false);

            // move to the next step form
            nextStep();
        } catch (error) {
            console.error('Request Authorize.Net Token: ', error);
            throw error;
        }
    };

    return { isLoading, requestAuthorizeToken };
};

export default useAuthorizeToken;
